(function () {
  'use strict';

  // ── Storage ────────────────────────────────────────────────────────────────
  var STORAGE_KEY = 'compare-list';
  var MAX = 3;

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function addProduct(handle) {
    var list = getList();
    if (list.indexOf(handle) !== -1) return true;
    if (list.length >= MAX) return false;
    list.push(handle);
    saveList(list);
    return true;
  }

  function removeProduct(handle) {
    saveList(getList().filter(function (h) { return h !== handle; }));
  }

  // Show the "Added to Compare" toast (shared by direct add and Undo).
  function showAddedToast() {
    showCompareToast({
      type: 'added',
      title: 'Added to Compare',
      subtitle: getList().length + ' of ' + MAX + ' selected',
      action: { label: 'View', onClick: openModal }
    });
  }

  // Show the "Compare limit reached" toast (when adding past MAX).
  function showLimitToast() {
    showCompareToast({
      type: 'limit',
      title: 'Compare limit reached',
      subtitle: 'You can only compare ' + MAX + ' items',
      action: { label: 'View (' + getList().length + ')', onClick: openModal }
    });
  }

  // Remove + show the "Removed from Compare" toast with an Undo (re-add) action.
  // Does NOT call syncAll - the caller is responsible for UI sync.
  function removeProductWithToast(handle) {
    removeProduct(handle);
    showCompareToast({
      type: 'removed',
      title: 'Removed from Compare',
      subtitle: getList().length + ' of ' + MAX + ' selected',
      action: {
        label: 'Undo',
        onClick: function () {
          if (addProduct(handle)) { // re-add the just-removed product
            syncAll();
            renderModalIfOpen();
            showAddedToast(); // stacks under the removed toast (which self-dismisses)
          }
        }
      }
    });
  }

  // Re-render the modal columns if it is currently open (used by Undo).
  function renderModalIfOpen() {
    var modal = document.getElementById('CompareModal');
    if (modal && !modal.hasAttribute('hidden')) renderModal();
  }

  // ── UI sync ────────────────────────────────────────────────────────────────
  function syncAll() {
    var list = getList();

    // Update FAB count
    var countEl = document.querySelector('.compare-fab__count');
    if (countEl) countEl.textContent = list.length;

    // Update all toggle buttons
    document.querySelectorAll('[data-compare-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-compare-handle');
      var active = list.indexOf(handle) !== -1;
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-active', active);
    });
  }

  // ── Toggle buttons on cards ────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare-handle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-compare-handle');
    var list = getList();

    if (list.indexOf(handle) !== -1) {
      removeProductWithToast(handle);
    } else {
      var added = addProduct(handle);
      if (added) {
        showAddedToast();
      } else {
        // At cap - shake the button and warn via toast
        btn.classList.add('compare-shake');
        btn.addEventListener('animationend', function () {
          btn.classList.remove('compare-shake');
        }, { once: true });
        showLimitToast();
      }
    }

    syncAll();
  });

  // ── FAB open modal ─────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.compare-fab__btn')) return;
    openModal();
  });

  // ── Modal close ────────────────────────────────────────────────────────────
  // Close on: the X / overlay (explicit [data-compare-close]) OR a click that lands
  // on the modal backdrop itself (target === the modal element) - matches the theme's
  // ModalDialog pattern (global.js: `if (event.target === this) this.hide()`).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-compare-close]') || e.target.id === 'CompareModal') {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function openModal() {
    var modal = document.getElementById('CompareModal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    renderModal();
  }

  function closeModal() {
    var modal = document.getElementById('CompareModal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  // ── Modal render ───────────────────────────────────────────────────────────
  function renderModal() {
    var modal = document.getElementById('CompareModal');
    if (!modal) return;

    var columnsEl = modal.querySelector('[data-columns]');
    var emptyEl   = modal.querySelector('[data-empty]');
    var list      = getList();

    columnsEl.innerHTML = '';

    columnsEl.setAttribute('data-count', list.length);
    var frameEl = modal.querySelector('.compare-modal__frame');
    if (frameEl) frameEl.setAttribute('data-count', list.length);

    if (list.length === 0) {
      if (emptyEl) emptyEl.removeAttribute('hidden');
      return;
    }
    if (emptyEl) emptyEl.setAttribute('hidden', '');

    list.forEach(function (handle) {
      fetchColumn(handle, columnsEl);
    });
  }

  function fetchColumn(handle, container) {
    fetch('/products/' + handle + '?section_id=compare-column')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var col = tmp.querySelector('.compare-column');
        if (!col) return;
        container.appendChild(col);
      })
      .catch(function () {});
  }

  // Wire Remove buttons inside modal (delegated)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare-remove]');
    if (!btn) return;
    var col = btn.closest('.compare-column');
    if (!col) return;
    var handle = col.getAttribute('data-handle');
    if (handle) removeProductWithToast(handle);
    col.remove();
    syncAll();
    // Show empty if no columns left; keep count attr in sync so layout re-fits
    var modal = document.getElementById('CompareModal');
    if (modal) {
      var columnsEl = modal.querySelector('[data-columns]');
      var frameEl = modal.querySelector('.compare-modal__frame');
      var remaining = modal.querySelectorAll('.compare-column');
      if (columnsEl) columnsEl.setAttribute('data-count', remaining.length);
      if (frameEl) frameEl.setAttribute('data-count', remaining.length);
      var emptyEl = modal.querySelector('[data-empty]');
      if (remaining.length === 0 && emptyEl) emptyEl.removeAttribute('hidden');
    }
  });

  // Wire Add to Cart inside modal (delegated)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.compare-column__cart [type="submit"]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    var id = form.querySelector('[name="id"]').value;

    // This theme's <cart-drawer> (cart.js: extends DrawerElement) refreshes itself by
    // listening for the `cart:refresh` document event - it re-fetches its own section by
    // section_id and (when detail.open === true) opens the drawer. So: add, then dispatch
    // cart:refresh. (The Dawn-style renderContents/sections-in-add.js flow is NOT this theme.)
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 }),
    })
    .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
    .then(function (res) {
      if (!res.ok || (res.data && res.data.status)) {
        return; // add failed (e.g. sold out)
      }
      // Close the compare modal so the drawer isn't behind it.
      closeModal();
      // Refresh the theme's cart drawer contents (onCartRefresh re-fetches its section).
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      // Belt-and-suspenders open: if the drawer isn't open yet, click its control.
      // Guard on the `open` ATTRIBUTE (the theme's real open state via `get open()`),
      // NOT the `active` class - active lags/omits in some paths and a false check
      // would click the already-open drawer and toggle it shut.
      setTimeout(function () {
        var cd = document.querySelector('cart-drawer');
        if (cd && !cd.hasAttribute('open')) {
          var ctrl = document.querySelector('a.cart-drawer-button[aria-controls="' + cd.id + '"]')
                  || document.querySelector('[aria-controls="' + cd.id + '"]');
          if (ctrl) ctrl.click();
        }
      }, 300);
      // Update header / drawer counters (they listen for the theme's cartUpdate pubsub).
      publishCartUpdate(id);
    })
    .catch(function () {})
    .finally(function () { btn.disabled = false; });
  });

  // Fetch the full cart state and broadcast the theme's cartUpdate event so all
  // cart-count / cart-icon-bubble listeners refresh. Falls back silently if the
  // theme pubsub isn't available.
  function publishCartUpdate(variantId) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.theme && theme.pubsub && typeof theme.pubsub.publish === 'function') {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'compare-modal',
            productVariantId: variantId,
            cart: cart
          });
        }
      })
      .catch(function () {});
  }

  // ── Toasts ─────────────────────────────────────────────────────────────────
  var toastHost = null;
  var MAX_TOASTS = 3; // cap the stack so rapid clicks don't pile up endlessly

  function getToastHost() {
    if (toastHost) return toastHost;
    toastHost = document.createElement('div');
    toastHost.className = 'compare-toast-host';
    document.body.appendChild(toastHost);
    return toastHost;
  }

  var TOAST_ICONS = {
    // green check - for "added"
    added:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M5 12.5L10 17.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // two-way swap arrows - for "removed"
    removed:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M7 8H19L15.5 4.5M17 16H5L8.5 19.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    // warning triangle - for "limit"
    limit:
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 4L21 19H3L12 4Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M12 10V13.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="12" cy="16.3" r="1" fill="currentColor"/></svg>'
  };

  // opts: { type:'added'|'removed', title, subtitle, action:{label, onClick}, duration }
  function showCompareToast(opts) {
    opts = opts || {};
    var host = getToastHost();

    // Toasts stack (newest at the bottom). Drop the oldest if we exceed the cap.
    var existing = host.querySelectorAll('.compare-toast');
    if (existing.length >= MAX_TOASTS) dismissCompareToast(existing[0]);

    var type = opts.type || 'added';
    var iconSvg = TOAST_ICONS[type] || TOAST_ICONS.added;

    var toast = document.createElement('div');
    toast.className = 'compare-toast compare-toast--' + type;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var title = opts.title || '';
    var subtitle = opts.subtitle || '';
    var action = opts.action || null;

    toast.innerHTML =
      '<span class="compare-toast__icon">' + iconSvg + '</span>' +
      '<span class="compare-toast__text">' +
        '<span class="compare-toast__title"></span>' +
        (subtitle ? '<span class="compare-toast__subtitle"></span>' : '') +
      '</span>' +
      (action ? '<button type="button" class="compare-toast__view"></button>' : '');

    toast.querySelector('.compare-toast__title').textContent = title;
    if (subtitle) toast.querySelector('.compare-toast__subtitle').textContent = subtitle;

    if (action) {
      var actionBtn = toast.querySelector('.compare-toast__view');
      actionBtn.textContent = action.label || 'View';
      actionBtn.addEventListener('click', function () {
        if (typeof action.onClick === 'function') action.onClick();
        dismissCompareToast(toast);
      });
    }

    host.appendChild(toast);
    // Force reflow then add the visible class so the entrance transition plays.
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    // Each toast owns its own auto-dismiss timer (stored on the element so stacking works).
    toast._timer = setTimeout(function () { dismissCompareToast(toast); }, opts.duration || 3500);
  }

  function dismissCompareToast(toast) {
    if (!toast || toast._dismissing) return;
    toast._dismissing = true;
    if (toast._timer) { clearTimeout(toast._timer); toast._timer = null; }
    toast.classList.remove('is-visible');
    toast.addEventListener('transitionend', function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, { once: true });
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  syncAll();

})();
